import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import FlashTicker from "./components/FlashTicker";
import FlashFeed from "./components/FlashFeed";
import TopicWall from "./components/TopicWall";
import CoverFeatures from "./components/CoverFeatures";
import Timeline from "./components/Timeline";
import CollectionsIndex from "./components/CollectionsIndex";
import PhotoGallery from "./components/PhotoGallery";
import Ranking from "./components/Ranking";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="w-full flex-1">
        <Hero />
        <FlashTicker />
        <FlashFeed />
        <TopicWall />
        <CoverFeatures />
        <Timeline />
        <CollectionsIndex />
        <PhotoGallery />
        <Ranking />
      </main>
      <SiteFooter />
    </div>
  );
}